// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/responsive.css
// module id = 2014
// module chunks = 0